<template>
  <div class="main">
    <HeaderTitle title="Post Order">
      <IconPostOrder color="#14444f" size="w-11 h-11" />
    </HeaderTitle>
    <MainContent>
      <div class="pb-5">
        <FullCalendar
          class="fullCalendar px-5 py-5 bg-gray-100"
          id="postOrderCal"
          ref="postOrderCal"
          :options="calendarOptions"
        >
          <template v-slot:eventContent="sch">
            <span
              class="text-gray-500 font-semibold text-center text-xs py-3"
              v-if="calView == 'dayGridMonth'"
            >
              {{ sch.event.title }} post orders
            </span>
          </template>
        </FullCalendar>
      </div>
    </MainContent>
  </div>
  <div id="loading-overlay" v-if="countByDate.loading">
    <LoadingLoad id="loading" size="w-14 h-14" />
  </div>
</template>
<script>
import HeaderTitle from "@/components/HeaderTitle.vue";
import IconPostOrder from "@/components/icons/IconPostOrder.vue";
import MainContent from "@/components/MainContent.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import multiMonthPlugin from "@fullcalendar/multimonth";
import LoadingLoad from "@/components/LoadingLoad.vue";
import { usePostOrderStore } from "@/store";
import { storeToRefs } from "pinia";
import { reactive, ref, watch } from "vue";

export default {
  components: {
    HeaderTitle,
    IconPostOrder,
    MainContent,
    FullCalendar,
    LoadingLoad,
  },
  setup() {
    const postOrderStore = usePostOrderStore();
    const { countByDate } = storeToRefs(postOrderStore);

    const postOrderCal = ref(null);
    const countData = ref([]);
    const calView = ref("dayGridMonth");
    const sum = ref(0);
    let lastMonth = null;
    let lastYear = null;

    const updateCustomButton = (value) => {
      const calendarApi = postOrderCal.value?.getApi();
      if (!calendarApi) return;
      calendarApi.setOption("customButtons", {
        total: {
          text: `Total: ${value.toLocaleString("id-ID")} Post Orders`,
        },
      });
    };

    const calendarOptions = reactive({
      plugins: [dayGridPlugin, multiMonthPlugin],
      customButtons: {
        total: {
          text: `Total: 0 Post Orders`,
        },
      },
      headerToolbar: {
        left: "total",
        center: "title",
        right: "prev,today,next,multiMonthYear",
      },
      buttonText: {
        today: "Today",
        year: "Year",
      },
      initialView: "dayGridMonth",
      events: [],
      selectable: true,
      dayMaxEvents: true,
      weekends: true,
      datesSet: () => {
        const calendarApi = postOrderCal.value.getApi();
        const viewType = calendarApi.currentData.currentViewType;

        if (viewType === "multiMonthYear") {
          calView.value = "multiMonthYear";
          updateCustomButton(0);

          const headers = document.querySelectorAll(".fc-multimonth-title");

          headers.forEach((el) => {
            el.style.cursor = "pointer";
            el.onclick = () => {
              const yearText = document
                .querySelector(".fc-toolbar-title")
                ?.innerText.trim();

              const monthName = el.innerText.trim();
              const monthIndex = new Date(
                `${monthName} 1, ${yearText}`
              ).getMonth();

              calendarApi.changeView("dayGridMonth");
              calendarApi.gotoDate(new Date(yearText, monthIndex, 1));
            };
          });
        } else {
          calView.value = "dayGridMonth";
          const currentDate = calendarApi.getDate();
          const m = currentDate.getMonth() + 1;
          const y = currentDate.getFullYear();

          if (m !== lastMonth || y !== lastYear) {
            lastMonth = m;
            lastYear = y;
            getCountByDate(y, m);
          }

          updateCustomButton(sum.value);
        }
      },
    });

    const getCountByDate = async (year, month) => {
      const calendarApi = postOrderCal.value.getApi();
      countData.value = [];
      sum.value = 0;

      await postOrderStore.getCountByDate({ year: year, month: month });

      const result = countByDate.value.result;

      result.forEach((item, i) => {
        countData.value.push({
          id: i + 1,
          title: item.jumlah_post_order,
          start: item.tanggal,
          allDay: true,
          color: "#00000000",
        });
        sum.value += parseInt(item.jumlah_post_order);
      });

      calendarApi.removeAllEvents();
      calendarApi.addEventSource(countData.value);

      updateCustomButton(sum.value);
    };

    watch(sum, (newVal) => {
      updateCustomButton(newVal);
    });

    return {
      postOrderCal,
      calendarOptions,
      countByDate,
      calView,
    };
  },
};
</script>
<style>
.fc .fc-total-button {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #6b7280 !important;
  font-weight: 600;
  font-size: 13px;
  line-height: 1rem;
  margin-top: 20px;
  cursor: text !important;
  pointer-events: none;
}

.fc .fc-total-button:hover,
.fc .fc-total-button:focus {
  background: transparent !important;
  color: #6b7280 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
